// Animates the open/close of every .piv-accordion (a native <details>
// element -- see migrate_dnn_page.py's _merge_accordion_pairs) with a
// slide. CSS alone can't do this: toggling a <details>'s `open`
// attribute is a discrete, UA-driven state flip that never gives a CSS
// transition a "before" frame to interpolate from (confirmed live,
// 2026-09-30 -- a grid-template-rows transition keyed off [open] never
// fired, despite otherwise-correct computed styles). This script
// intercepts the click and animates .piv-accordion-body's height
// directly instead. If it fails to load, the accordion still works via
// the browser's native instant open/close -- this only adds the
// animation on top.
(function () {
  var DURATION_MS = 300;

  function setUp(details) {
    var summary = details.querySelector(":scope > summary");
    var body = details.querySelector(":scope > .piv-accordion-body");
    if (!summary || !body || details.__pivAccordionBound) return;
    details.__pivAccordionBound = true;
    var animating = false;

    function reduceMotion() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    function clearInlineStyles() {
      body.style.transition = "";
      body.style.height = "";
      animating = false;
    }

    function expand() {
      animating = true;
      details.open = true;
      var target = body.scrollHeight;
      body.style.height = "0px";
      body.offsetHeight; // force layout so 0px is committed before animating
      body.style.transition = "height " + DURATION_MS + "ms ease";
      body.style.height = target + "px";
      body.addEventListener("transitionend", onExpandEnd);
    }

    function onExpandEnd(e) {
      if (e.propertyName !== "height") return;
      body.removeEventListener("transitionend", onExpandEnd);
      clearInlineStyles();
    }

    function collapse() {
      animating = true;
      body.style.height = body.scrollHeight + "px";
      body.offsetHeight; // force layout so the explicit height is committed
      body.style.transition = "height " + DURATION_MS + "ms ease";
      body.style.height = "0px";
      body.addEventListener("transitionend", onCollapseEnd);
    }

    function onCollapseEnd(e) {
      if (e.propertyName !== "height") return;
      body.removeEventListener("transitionend", onCollapseEnd);
      details.open = false;
      clearInlineStyles();
    }

    summary.addEventListener("click", function (e) {
      if (reduceMotion()) return;
      e.preventDefault(); // always, once we own the toggle -- otherwise a
      // click that arrives mid-animation (below) would fall through to
      // the browser's native toggle and desync `open` from our inline
      // height/transition state.
      if (animating) return;
      if (details.open) {
        collapse();
      } else {
        expand();
      }
    });
  }

  document.querySelectorAll(".piv-accordion").forEach(setUp);
})();

// Lightbox (modal) for links marked  <a href="full.png" data-piv-lightbox="group"
// data-piv-lightbox-caption="optional caption">. Replaces DNN's fancybox: links that share a
// group name can be stepped through with the arrows / keyboard. Add data-piv-lightbox-type="pdf"
// to show a PDF in a framed viewer instead of an image (on phones, where browsers can't show a
// PDF in a frame, such links are not intercepted and just open in a new tab -- give them
// target="_blank"). Delegated click handler, so it
// does nothing on pages without such links; if this script fails to load the link simply opens
// the image (its normal href). Esc / backdrop click / X close it; focus is kept inside the
// dialog while open and returned to the link afterwards. Styles: .piv-lightbox in
// piv-migrated-pages.css.
(function () {
  var overlay, scroller, img, frame, caption, counter, newTab, closeBtn, prevBtn, nextBtn;
  var items = [];
  var index = 0;
  var returnFocus = null;

  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    for (var k in attrs || {}) n.setAttribute(k, attrs[k]);
    return n;
  }

  function build() {
    overlay = el("div", "piv-lightbox", { role: "dialog", "aria-modal": "true", "aria-label": "Image viewer", hidden: "" });
    closeBtn = el("button", "piv-lightbox__btn piv-lightbox__close", { type: "button", "aria-label": "Close" });
    closeBtn.innerHTML = "&times;";
    prevBtn = el("button", "piv-lightbox__btn piv-lightbox__prev", { type: "button", "aria-label": "Previous image" });
    prevBtn.innerHTML = "&#10094;";
    nextBtn = el("button", "piv-lightbox__btn piv-lightbox__next", { type: "button", "aria-label": "Next image" });
    nextBtn.innerHTML = "&#10095;";
    var figure = el("figure", "piv-lightbox__figure");
    scroller = el("div", "piv-lightbox__scroller");
    img = el("img", "piv-lightbox__img", { alt: "" });
    scroller.appendChild(img);
    frame = el("iframe", "piv-lightbox__frame", { title: "Document viewer" });
    caption = el("figcaption", "piv-lightbox__caption");
    counter = el("span", "piv-lightbox__counter");
    newTab = el("a", "piv-lightbox__newtab", { target: "_blank", rel: "noopener" });
    newTab.textContent = "Open in a new tab";
    figure.appendChild(scroller);
    figure.appendChild(frame);
    figure.appendChild(caption);
    figure.appendChild(newTab);
    overlay.appendChild(closeBtn);
    overlay.appendChild(prevBtn);
    overlay.appendChild(nextBtn);
    overlay.appendChild(figure);
    document.body.appendChild(overlay);

    closeBtn.addEventListener("click", close);
    prevBtn.addEventListener("click", function () { show(index - 1); });
    nextBtn.addEventListener("click", function () { show(index + 1); });
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) close(); // backdrop, not the image/figure
    });
    img.addEventListener("error", function () {
      // Image could not load: fall back to the plain link behaviour.
      var href = items[index] && items[index].href;
      close();
      if (href) window.open(href, "_blank", "noopener");
    });
  }

  function label(a) {
    return a.getAttribute("data-piv-lightbox-caption") || a.textContent.replace(/\s+/g, " ").trim();
  }

  function show(i) {
    if (items.length < 1) return;
    index = (i + items.length) % items.length;
    var a = items[index];
    var type = a.getAttribute("data-piv-lightbox-type");
    var isPdf = type === "pdf";
    var isVideo = type === "video";
    overlay.classList.toggle("piv-lightbox--frame", isPdf);
    overlay.classList.toggle("piv-lightbox--video", isVideo);
    overlay.setAttribute("aria-label", isVideo ? "Video player" : "Image viewer");
    if (isVideo) {
      // data-piv-lightbox-type="video": plays data-piv-lightbox-embed (an embeddable player URL, e.g. YouTube /embed/ID?autoplay=1)
      // in a 16:9 frame; the link's own href is only the no-JS fallback (the plain video page).
      img.removeAttribute("src");
      frame.title = label(a);
      frame.setAttribute("allow", "autoplay; encrypted-media; fullscreen; picture-in-picture");
      frame.setAttribute("allowfullscreen", "");
      frame.src = a.getAttribute("data-piv-lightbox-embed") || a.href;
    } else if (isPdf) {
      img.removeAttribute("src");
      frame.removeAttribute("allow");
      frame.title = label(a);
      frame.src = a.href;
      newTab.href = a.href;
    } else {
      frame.removeAttribute("allow");
      frame.removeAttribute("src");
      img.alt = label(a);
      img.src = a.href;
    }
    caption.textContent = label(a) + (items.length > 1 ? "  (" + (index + 1) + " / " + items.length + ")" : "");
    scroller.scrollTop = 0;
    scroller.scrollLeft = 0;
    var many = items.length > 1;
    prevBtn.hidden = nextBtn.hidden = !many;
    if (many && !isPdf && !isVideo && !items[(index + 1) % items.length].getAttribute("data-piv-lightbox-type")) { // warm the cache for the neighbour
      var nb = new Image();
      nb.src = items[(index + 1) % items.length].href;
    }
  }

  function open(link) {
    if (!overlay) build();
    var group = link.getAttribute("data-piv-lightbox");
    items = Array.prototype.filter.call(document.querySelectorAll("a[data-piv-lightbox]"), function (a) {
      return a.getAttribute("data-piv-lightbox") === group;
    });
    returnFocus = link;
    show(items.indexOf(link));
    overlay.hidden = false;
    document.documentElement.classList.add("piv-lightbox-open");
    closeBtn.focus();
    document.addEventListener("keydown", onKey, true);
  }

  function close() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    img.removeAttribute("src");
    frame.removeAttribute("src");
    document.documentElement.classList.remove("piv-lightbox-open");
    document.removeEventListener("keydown", onKey, true);
    if (returnFocus && returnFocus.focus) returnFocus.focus();
    returnFocus = null;
  }

  function onKey(e) {
    if (e.key === "Escape") {
      e.preventDefault();
      close();
    } else if (e.key === "ArrowLeft" && items.length > 1) {
      show(index - 1);
    } else if (e.key === "ArrowRight" && items.length > 1) {
      show(index + 1);
    } else if (e.key === "Tab") { // keep focus inside the dialog
      var f = [closeBtn, prevBtn, nextBtn, newTab].filter(function (b) { return !b.hidden && (b !== newTab || overlay.classList.contains("piv-lightbox--frame")); });
      var at = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(at + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
    }
  }

  document.addEventListener("click", function (e) {
    var link = e.target.closest && e.target.closest("a[data-piv-lightbox]");
    if (!link || e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; // let "open in new tab" work
    if (link.getAttribute("data-piv-lightbox-type") === "pdf" &&
        window.matchMedia("(max-width: 749px), (pointer: coarse)").matches) return; // phones/tablets: plain link
    e.preventDefault();
    open(link);
  });
})();

// A jump link (#id, also on load / hashchange) that targets a closed accordion -- the <details>
// itself, something inside it, or a .piv-section whose only content is one accordion (e.g. the
// "Eligibility and Code of Conduct" section on the Pali workshop pages) -- opens it, so the
// reader lands on the content rather than on a collapsed bar. Without this script the link still
// scrolls to the section; the accordion just stays closed.
(function () {
  function reveal(id) {
    if (!id) return;
    var target;
    try { target = document.getElementById(decodeURIComponent(id)); } catch (e) { return; }
    if (!target) return;
    var details = target.closest("details.piv-accordion");
    if (!details && target.classList.contains("piv-section")) {
      var own = target.querySelectorAll(":scope > details.piv-accordion");
      if (own.length === 1) details = own[0];
    }
    if (details && !details.open) details.open = true;
  }
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (a) reveal(a.getAttribute("href").slice(1));
  });
  window.addEventListener("hashchange", function () { reveal(location.hash.slice(1)); });
  if (location.hash) reveal(location.hash.slice(1));
})();
